import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const onlineDpoComponent: ComponentDef = {
  id: 'online-dpo',
  name: 'Online DPO',
  description: 'Online Direct Preference Optimization samples pairs on-the-fly and updates the policy with a preference loss.',
  category: 'training',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'seq_len', label: 'Sequence length', type: 'number', default: 128, min: 1, max: 8192, step: 1 }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const seq_len = Number(params.seq_len);

    const g = new GraphBuilder();
    g.input('prompt', [seq_len, d_model]);

    g.linear('chosen', 'prompt', [d_model, d_model]);
    g.linear('rejected', 'prompt', [d_model, d_model]);
    g.linear('reference', 'prompt', [d_model, d_model]);
    g.scale('ref_chosen', 'reference', 'ref chosen');
    g.scale('ref_rejected', 'reference', 'ref rejected');
    g.add('margin', 'chosen', 'ref_chosen');
    g.add('reject_margin', 'rejected', 'ref_rejected');
    g.crossEntropy('preference', 'margin', 'reject_margin');
    g.output('out', 'preference');
    return g.build();
  }
};
